import { z } from "zod";

/**
 * Role granted to the test user within a project.
 */
export const e2eRoles = ["owner", "developer", "approver", "viewer"] as const;
export const e2eRoleSchema = z.enum(e2eRoles);
export type E2eRole = z.infer<typeof e2eRoleSchema>;

/**
 * Request payload to obtain a test sign-in session.
 */
export const e2eSignInRequestSchema = z.object({
  email: z.string().email(),
  displayName: z.string().min(1).default("E2E Test User"),
  projectId: z.string().uuid().optional(),
  projectName: z.string().min(1).optional(),
  role: e2eRoleSchema.default("owner"),
  /** HMAC SHA-256 signature (64 hex characters) proving knowledge of E2E_SIGNING_KEY */
  signature: z.string().regex(/^[0-9a-fA-F]{64}$/, "Signature must be a 64-character hex string"),
  /** UNIX timestamp in milliseconds when signature was generated */
  timestamp: z.number().int().positive(),
});
export type E2eSignInRequest = z.infer<typeof e2eSignInRequestSchema>;

/**
 * Response payload from test sign-in.
 */
export const e2eSignInResponseSchema = z.object({
  authenticated: z.literal(true),
  user: z.object({
    id: z.string(),
    email: z.string(),
    displayName: z.string(),
  }),
  projectId: z.string().optional(),
  role: e2eRoleSchema.optional(),
});
export type E2eSignInResponse = z.infer<typeof e2eSignInResponseSchema>;
